<template>
  <div>
    <el-row>
      <el-col :span="24" class="text-right"></el-col>
    </el-row>

    <div class="margin-top">
      <el-table
        :data="productDetailOutstockInfo.orders"
        border
        style="width: 100%"
        size="small"
      >
        <el-table-column prop="orderId" label="订单编号" align="center" />
        <el-table-column prop="personName" label="申请人" align="center" />
        <el-table-column prop="createTime" label="申请时间" align="center" />
        <el-table-column prop="stateName" label="状态" align="center" />
        <el-table-column prop="prodName" label="商品名称" align="center" />
        <el-table-column prop="specName" label="规格" align="center" />
        <el-table-column prop="prodCount" label="数量" align="center" />
        <el-table-column prop="price" label="价格" align="center" />
        <el-table-column prop="amount" label="金额" align="center" />
      </el-table>

      <el-row class="margin-top">
        <el-col :span="12"></el-col>
        <el-col :span="12" class="text-right">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="pagination.currentPage"
            :page-size="pagination.pageSize"
            layout="total, prev, pager, next"
            :total="pagination.total"
          />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { queryInoutOrderProduct } from '@/api/goods/productDetailApi'

export default {
  name: 'ProductDetailOutstock',
  data() {
    return {
      productDetailOutstockInfo: {
        orders: [],
        productId: ''
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  methods: {
    open(params) {
      this.productDetailOutstockInfo.productId = params.productId
      this.loadProductDetailOutstockData()
    },
    async loadProductDetailOutstockData() {
      const res = await queryInoutOrderProduct({
          productId: this.productDetailOutstockInfo.productId,
          page: this.pagination.currentPage,
          row: this.pagination.pageSize,
          shopId: getShopId(),
          orderType: '20000'
      })
      this.productDetailOutstockInfo.orders = res.data
      this.pagination.total = res.records
    },
    handleCurrentChange(currentPage) {
      this.pagination.currentPage = currentPage
      this.loadProductDetailOutstockData()
    }
  }
}
</script>

<style scoped>
.margin-top {
  margin-top: 20px;
}
.text-right {
  text-align: right;
}
</style>